import { Component, Inject, OnInit, ViewEncapsulation, Input, PLATFORM_ID, ViewChild, ElementRef, AfterViewInit, AfterViewChecked } from '@angular/core';
import { LandingModelService } from 'projects/common/services/landingModel.service';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Module } from 'projects/common/model/ModuleModel';
import { OffersService } from 'projects/common/services/offers.service';
import { FaqsService } from 'projects/common/services/faqs.service';
import { InterlinksService } from 'projects/common/services/interlinks.service';
import { ModuleService } from 'projects/common/services/module.service';
import { CustomTimmingsService } from 'projects/common/services/custom-timming-service.service';
import { UpaService, UpaTarget } from 'projects/common/services/upa.service';
import { Currency, LandingModel } from 'projects/common/model/landingModel';
import { EmtpyStateService } from 'projects/common/services/empty-state.service';
import { Device } from 'projects/common/model/Device';

declare var window: any;

@Component({
  selector: 'meta-component',
  template: `
    <div *ngIf="module.titles_outside_module && (module.pretitle || module.title || module.subtitle)" class="titles-outside-modules titles-module-{{module.id}}">
      <text class="eva-3-container" *ngIf="module.pretitle || module.title || module.subtitle" [data]="module"></text>
    </div>

    <div #container class="content-wrapper section section-{{module.row_number}} module-{{module.id + (module.data?.version || '')}} {{module.data?.view_type || ''}} {{  module.data?.view_full_width ? '' : 'eva-3-container'}}" 
        [ngSwitch]="module.id" *ngIf="!xDespShowInfo || module.data" [style]="getBackgroundImage(module)">
      
      <div class="bg-color-wrapper" [ngStyle]="resolveBackgroundColorModule(module)">

        <multicurrency *ngSwitchCase="offerModulesCount() > 0 ? 'CurrencyFilterModule': !module.id" [module]="module"
                        [moduleIndex]="module.row_number" [uniqueId]="module.unique_id"></multicurrency>

        <eva-message *ngSwitchCase="'EvaMessageModule'" [module]="module" [data]="module.data" [uniqueId]="module.unique_id" [moduleIndex]="module.row_number"></eva-message>
        <sbox *ngSwitchCase="'SBoxModule'" [sboxModule]="module.data" [module]="module" [title]="module.title"
                          [subtitle]="module.subtitle" [modulePosition]="module.row_number" [moduleId]="module.id" [uniqueId]="module.unique_id"></sbox>
        <text-list *ngSwitchCase="'TextListModule'" [module]="module"></text-list>
        <text *ngSwitchCase="['TextModule', 'TextPackageModule'].includes(module.id) && module.id" [module]="module"
              [data]="module.data" [moduleId]="module.id" [moduleIndex]="module.row_number" [product]="product" [flow]="flow"></text>

        <text-and-image *ngSwitchCase="'TextAndImageModule'" [module]="module"></text-and-image>
        <picture-component *ngSwitchCase="'PictureModule'" [module]="module" ></picture-component>
        <picture-list-component *ngSwitchCase="'PictureListModule'" [module]="module" [flow]="flow"></picture-list-component>
        <eva-cards-wrapper
          *ngSwitchCase="['EvaCardsWrapperModule', 'InterlinksGeoModule', 'LandingTypeInterlinksModule', 'HotelRoomTypesCardsModule', 'ReviewItemsModule', 'PaymentMethodsModule'].includes(module.id) && module.id"
          [module]="castModule(module)" [device]="device"
          [flow]="flow"></eva-cards-wrapper>
        <paragraphs *ngSwitchCase="'ParagraphsModule'" [module]="module"></paragraphs>
        <banner-icon *ngSwitchCase="'BannerIconModule'" [module]="module" [flow]="flow"></banner-icon>
        <banner-background *ngSwitchCase="'BannerBackgroundModule'" [module]="module"></banner-background>
        <covid *ngSwitchCase="'CovidModule'" [module]="module" [flow]="flow"></covid>
        <inter-link *ngSwitchCase="'InterLinkModule'" [module]="module" [device]="device"></inter-link>
        <offers
          *ngSwitchCase="offersModules.includes(module.id) && (!module.offer_view_type || ['HIGHLIGHTED', 'VERTICAL'].includes(module.offer_view_type)) && module.id"
          [module]="castModule(module)" [currency]="currency" [flow]="flow" [allRowVisible]="offerModulesCount() === 1"></offers>
        <clusters
          *ngSwitchCase="offersModules.includes(module.id) && module.offer_view_type === 'HORIZONTAL' && module.id"
          [module]="module" [flow]="flow"
          [currency]="currency" [device]="device"></clusters>
        <empty-state *ngSwitchCase="appliesEmptyState() && module.id" [module]="module" [moduleId]="module.id" [moduleIndex]="module.row_number" [uniqueId]="module.unique_id"></empty-state>
        <draper-banner-wrapper *ngSwitchCase="'DraperBannerModule'" [module]="module"></draper-banner-wrapper>
        <origin-filter *ngSwitchCase="'OriginFilterModule'" [module]="module"></origin-filter>
        <document-viewer *ngSwitchCase="'DocumentModule'" [module]="module" [device]="device" [flow]="flow"></document-viewer>
        <grouped-interlink *ngSwitchCase="interlinksModules.includes(module.id) && module.id" [module]="module" [device]="device"></grouped-interlink>
        <frequently-asked-question *ngSwitchCase="faqsModules.includes(module.id) && module.id"
                                    [module]="module" [device]="device"></frequently-asked-question>
        <subscription-activation *ngSwitchCase="'SubscriptionActivationModule'" [module]="module" [flow]="flow"></subscription-activation>
        <subscription-form *ngSwitchCase="'SubscriptionFormModule'" [module]="module"></subscription-form>
        <offers-filters
          *ngSwitchCase="['HotelFiltersModule', 'OffersFiltersModule', 'PackageFiltersModule', 'ManualFiltersModule'].includes(module.id) && module.id"
          [module]="module" [currency]="currency"></offers-filters>
        <flex-safe-stay-banner-wrapper *ngSwitchCase="'FlexSafeStayBannerModule'" [module]="module"
                                        [flow]="flow"></flex-safe-stay-banner-wrapper>
        <video-miniatures *ngSwitchCase="'VideoModule'" [module]="module" [flow]="flow"></video-miniatures>
        <multi-banner *ngSwitchCase="'MultiBannerModule'" [module]="module" [device]="device" [flow]="flow"></multi-banner>
        <fare-suggestion-chart-container *ngSwitchCase="'FareSuggestionChartModule'" [module]='module' ></fare-suggestion-chart-container>
        <ads-regular-banners *ngSwitchCase="'AdsRegularBannersModule'" [module]="module"></ads-regular-banners>
        <iframe-embed *ngSwitchCase="'IframeModule'" [module]="module" [moduleId]="module.id" [device]="device"></iframe-embed>
        <youtube-embeded *ngSwitchCase="'YoutubeEmbeddedVideoModule'" [module]="module"></youtube-embeded>
        <grouped-modules *ngSwitchCase="'GroupedModules'" [module]="module" [currency]="currency" [device]="device" [offersModules]="offersModules" [interlinksModules]="interlinksModules" [faqsModules]="faqsModules" [flow]="flow" [product]="product" [locale]="locale"></grouped-modules>
        <user-recent-activity *ngSwitchCase="'UserRecentActivityModule'" [module]="module" [device]="device"></user-recent-activity>
        <reviews-summary *ngSwitchCase="'ReviewsSummaryModule'" [module]="module" [flow]="flow"></reviews-summary>
        <description-detailed *ngSwitchCase="['DescriptionDetailedModule', 'HotelDescriptionDetailedModule'].includes(module.id) && module.id"
          [module]="module"></description-detailed>
        <seals-banner *ngSwitchCase="'HotelSealsBannerModule'" [module]="module"></seals-banner>
        <map-module *ngSwitchCase="'HotelMapModule'" [module]="module" [flow]="flow" [product]="product"></map-module>
        <hotel-images-gallery *ngSwitchCase="'HotelDetailImageGalleryModule'" [module]="module" [flow]="flow" [product]="product"></hotel-images-gallery>
        <table-module *ngSwitchCase="'TableModule'" [module]="module" [screenType]="device.type" ></table-module>
        <wizumen *ngSwitchCase="'WizumenModule'" [flow]="flow" [wizumenModule]="castModule(module)" [device]="device" [locale]="locale" [isCollapsedByDefault]="hasActivePriorityEvent"></wizumen>
        <user-favorites *ngSwitchCase="'UserFavoritesModule'" [module]="module" [product]="product" [flow]="flow" [currency]="currency" [device]="device"></user-favorites>
        <form-module *ngSwitchCase="'FormModule'" [module]="module" [product]="product" [flow]="flow"></form-module>
        <chat-AI *ngSwitchCase="'ChatAIModule'" [module]="module" [product]="product" [flow]="flow"></chat-AI>
        <text-banner *ngSwitchCase="'TextBannerModule'" [module]="module"></text-banner>
        <reels *ngSwitchCase="'ReelsModule'" [flow]="flow" [module]="module" [moduleId]="module.id" [uniqueId]="module.unique_id || 'ReelsModule'"></reels>
        <user-landings *ngSwitchCase="'UserLandingsModule'" [flow]="flow" [module]="module" [moduleId]="module.id" [uniqueId]="module.unique_id || 'UserLandingsModule'"></user-landings>
        <user-landings-v2 *ngSwitchCase="'UserLandingsModuleV2'" [flow]="flow" [module]="module" [moduleId]="module.id" [uniqueId]="module.unique_id || 'UserLandingsModuleV2'" [device]="device"></user-landings-v2>
        <input-text-filter *ngSwitchCase="'InputTextFilterModule'" [module]="module" [moduleId]="module.id"></input-text-filter>
        <payment-promos *ngSwitchCase="'PaymentsPromosModule'" [module]="module" [moduleId]="module.id"></payment-promos>
        <itinerary *ngSwitchCase="'ItineraryModule'" [module]="module" [moduleId]="module.id" [flow]="flow" [currency]="currency" [device]="device"></itinerary>
        <flight-offers *ngSwitchCase="'FlightOffersModule'" [module]="module" [moduleIndex]="module.row_number" [flow]="flow" [currency]="currency" [device]="device" [allRowVisible]="offerModulesCount() === 1"></flight-offers>
        <alerts-banner *ngSwitchCase="'PriceAlertsBannerModule'" [module]="module" [moduleIndex]="module.row_number" [flow]="flow" [currency]="currency"></alerts-banner>
        <landing-history *ngSwitchCase="'LandingHistoryModule'" [module]="module"></landing-history>
        <event-dispatcher *ngSwitchCase="'SofiaPromptSuggestionsModule'" [module]="module" [moduleIndex]="module.row_number" [flow]="flow" [uniqueId]="module.unique_id"></event-dispatcher>
        <grid-container *ngSwitchCase="'GridContainerModule'" [module]="module" [currency]="currency" [device]="device" [flow]="flow"></grid-container>
        <subnav-module *ngSwitchCase="'SubnavModule'" [module]="module" [flow]="flow"></subnav-module>
      </div>
    </div>
    <div *ngIf="xDespShowInfo" class="eva-3-container info-metadata">
      <info-metadata [module]="module" />
    </div>
  `,
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./meta-component.component.scss']
})

export class MetaComponent implements OnInit, AfterViewInit, AfterViewChecked {
  @Input() module: Module;
  @Input() currency: Currency;
  @Input() device: Device;
  @Input() product: string;
  @Input() flow: string;
  @Input() isLastSSRModule: boolean;
  @Input() locale: string;
  @Input() containerId: string;
  @Input() hasActivePriorityEvent: boolean;
  @Input() onLastLoadedCallback: () => void;

  xDespShowInfo = false;

  faqsModules: Array<string>;
  offersModules: Array<string>;
  interlinksModules: Array<string>;

  timeTracked = false;
  upaData: any;
  landingModel: LandingModel;
  isLandingAssistance: boolean = false;

  @ViewChild('container') componentContainer: ElementRef;

  constructor(@Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: string,
    public landingModelService: LandingModelService,
    private moduleService: ModuleService,
    private customTimmingsService: CustomTimmingsService,
    private upaService: UpaService,
    private emptyStateService: EmtpyStateService,
  ) {
    this.offersModules = OffersService.getOffersModules();
    this.faqsModules = FaqsService.getFaqsModules();
    this.interlinksModules = InterlinksService.getInterlinksModules();
    this.landingModel = this.landingModelService.getLandingModel();
  }

  ngOnInit(): void {
    if (typeof window !== 'undefined' && window.xDespShowInfo) {
      this.xDespShowInfo = true;
    }
    this.isLandingAssistance = this.setIsLandingAssistance();

    this.subscribeToChatAssistanceLoaded();
  }

  ngAfterViewInit() {
    // Puede que se el módulo se devuelva vacío, ahí no se trackea
    if (isPlatformBrowser(this.platformId) && window?.upaData && (this.module.id !== 'FlightOffersModule' || this.module.data?.favorites_response?.favorites?.length > 0)) {
      this.trackWhenDisplayed();
    }
  }

  ngAfterViewChecked(): void {
    if (!this.isLandingAssistance && this.isLastSSRModule) {
      this.trackTimes();
      this.onLastLoadedCallback?.();
    }
  }

  subscribeToChatAssistanceLoaded(): void {
    if (isPlatformBrowser(this.platformId) && this.isLandingAssistance) {
      window.document.addEventListener('chat-assistance-loaded', this.trackTimes);
    }
  }

  unsubscribeFromChatAssistanceLoaded(): void {
    if (isPlatformBrowser(this.platformId) && this.isLandingAssistance) {
      window.document.removeEventListener('chat-assistance-loaded', this.trackTimes);
    }
  }

  setIsLandingAssistance (): boolean {
    return this.landingModel?.modules.some(module => module?.id === 'ChatAIModule' && module?.data?.version === 'V2') ?? false;
  }

  trackTimes = () => {
    if (isPlatformBrowser(this.platformId) && !this.timeTracked) {
      this.landingModel.times['main-feature'] = window.performance.now() / 1000;
      this.landingModel.times['SSR'] = window['SSR'];
      if (window.newrelic) {
        window.newrelic.addPageAction("times", this.landingModel.times);
      }
      this.customTimmingsService.trackLandingTimings(this.landingModel.times);
      this.timeTracked = true;

      this.unsubscribeFromChatAssistanceLoaded();
    }
  }

  resolveModuleStylesConfiguration(module: any) {
    return module?.container_styles ? this.convertStyleKeysFromUnderscoreToDash(module.container_styles) : {};
  }
  
  convertStyleKeysFromUnderscoreToDash(styles: any): any {
    return Object.fromEntries(
      Object.entries(styles).map(([key, value]) => [key.replace(/_/g, '-'), value])
    );
  }

  resolveBackgroundColorModule(module: any) {
    return [module, module?.data].find((x) => x?.background_module?.type == 'CONTENT_WIDTH') 
      ? this.moduleService.resolveBackgroundModule(module, this.device) 
      : this.resolveModuleStylesConfiguration(module);
  }

  getBackgroundImage(module) {
    const styles = {};
    if (module.background_image) {
      styles['background-repeat'] = 'no-repeat';
      styles['background-size'] = 'cover';
      const src = this.device.type === 'MOBILE' && module.background_image.src_mobile || module.background_image.src;
      styles['background-image'] = 'url(//media.staticontent.com/media/pictures/' + src + ')';
      styles['box-sizing'] = 'border-box';
      styles['margin-top'] = '25px';
      styles['margin-bottom'] = '25px';
      if (this.device.type == 'DESKTOP') {
        styles['padding-left'] = '0';
      }
    }
    return styles;
  }

  offerModulesCount(): number {
    // TODO revisar offersModules, agregar 'HotelsByCityModule' / crear otra lista para clusters / identificar como se van a dibujar las ofertas de otra forma
    return this.landingModelService.getLandingModel().modules.filter(module => this.offersModules.includes(module.id)).length;
  }

  castModule<M extends Module, T extends M>(module: M): T {
    return module as T;
  }

  trackWhenDisplayed() {
    if (!this.componentContainer?.nativeElement) return;

    const trackViewPort = (entry: IntersectionObserverEntry) => {
      if (entry.boundingClientRect.height > 0) this.upaService.trackViewPort(this.module.unique_id || 'unknown ' + this.module.id, this.module.id);
    }

    this.moduleService.onElementVisible(this.componentContainer.nativeElement, trackViewPort, true, { threshold: 0.5 });

    if (this.module.track_when_displayed) { // Trip planner legacy
      const trackTripPlanner = () => {
        this.upaService.trackView({ 
          label: 'VISIBLE',
          uniqueId: this.module.unique_id, 
          moduleId: this.module.id,
          moduleIndex: this.module.row_number,
          target: UpaTarget.TRIP_PLANNER 
        });
      }

      this.moduleService.onElementVisible(this.componentContainer.nativeElement, trackTripPlanner, true, { threshold: 0.2 });
    }
  }

  appliesEmptyState(): boolean {
    return this.emptyStateService.shouldShowEmptyState(this.module, this.containerId);
  }
}
